<template>
  <div
    ref="MainDialog"
    class="fixed inset-0 z-[100] hidden"
    aria-labelledby="modal-title"
    role="dialog"
    aria-modal="true"
  >
    <!-- 背景遮罩 (Backdrop) -->
    <div
      ref="modalBackdrop"
      class="fixed inset-0 transition-opacity duration-300 ease-out opacity-0 bg-black/40 backdrop-blur-sm"
    ></div>

    <!-- Modal 本體 (Panel) -->
    <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
      <div class="flex items-center justify-center min-h-full p-4 sm:p-0">
        <div
          ref="modalPanel"
          class="relative overflow-hidden text-left transition-all duration-300 ease-out transform scale-95 bg-white shadow-2xl opacity-0 rounded-2xl sm:my-8 sm:w-full sm:max-w-sm"
        >
          <div class="px-4 pt-5 pb-4 sm:p-6">
            <div class="flex flex-col items-start">
              <h3
                class="mb-4 text-lg font-bold leading-6 text-gray-900"
                ref="modalTitle"
              >
                訊息
              </h3>
              <!-- 文字區域 -->

              <div class="flex-1 min-h-40">
                <p class="text-sm text-gray-500" ref="modalMessage">
                  {{ dialog_content }}
                </p>
              </div>
            </div>
          </div>

          <!-- 按鈕區域 -->
          <div class="px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6 bg-gray-50">
            <button
              type="button"
              ref="modalConfirmBtn"
              @click="Close"
              class="inline-flex w-full justify-center rounded-lg bg-gray-800 px-3 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-gray-900 sm:w-full transition-colors"
            >
              確定
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MainDialog",
  data() {
    return {
      dialog_gsap: null,
      timer: null,
    };
  },
  methods: {
    OpenModal() {
      // 顯示並執行動畫
      this.$refs.MainDialog.classList.remove("hidden");
      // 小延遲讓瀏覽器抓到 display 變化，觸發 transition
      this.timer != null ? clearTimeout(this.timer) : "";
      this.timer = setTimeout(() => {
        this.$refs.modalBackdrop.classList.remove("opacity-0");
        this.$refs.modalPanel.classList.remove("scale-95", "opacity-0");
        this.$refs.modalPanel.classList.add("scale-100", "opacity-100");
      }, 10);
    },
    CloseModal() {
      this.$refs.modalBackdrop.classList.add("opacity-0");
      this.$refs.modalPanel.classList.remove("scale-100", "opacity-100");
      this.$refs.modalPanel.classList.add("scale-95", "opacity-0");
      this.timer != null ? clearTimeout(this.timer) : "";
      this.timer = setTimeout(() => {
        this.$refs.MainDialog.classList.add("hidden");
        // 執行並清空回調
        if (this.onConfirm) {
          this.onConfirm();
          this.onConfirm = null;
        }
      }, 300); // 等待動畫結束
    },
    Close() {
      this.$store.commit("SetDialog", {
        status: false,
        content: this.dialog_content,
      });
    },
  },
  watch: {
    dialog_status() {
      this.dialog_status ? this.OpenModal() : this.CloseModal();
    },
  },
  computed: {
    dialog_status() {
      return this.$store.state.main_dialog.status;
    },
    dialog_content() {
      return this.$store.state.main_dialog.content;
    },
  },
};
</script>
